
import { InsertData, InsertDataAuth, InsertDataWithImage } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import {
    CREATE_NEW_USER_Signup,
    LOGIN_USER,
    ChangePassword,
    FOREGT_PASSWORD,
    GET_USER_PROFULE,
    UPDATE_USER_PROFULE,
    
  } from "../type";
//create new user 
export const createNewUserAction = (data) => async (dispatch) => {
    try {
        const response = await InsertDataAuth (`/api/signup/`, data);
        dispatch({
            type: CREATE_NEW_USER_Signup,
            payload: response,
            loading: true
        }) 

    } catch (e) {
        dispatch({
            type: CREATE_NEW_USER_Signup,
            payload: e.response,
        })
    }
}

//login  user 
export const loginUseraction = (data) => async (dispatch) => {
    try {
        const response = await InsertDataAuth(`/api/login-token/`, data);
        dispatch({
            type: LOGIN_USER,
            payload: response,
            loading: true
        })
    } catch (e) {
        dispatch({
            type: LOGIN_USER,
            payload: e.response,
        })
    }
}

//login  user 
export const getuserprofileaction = () => async (dispatch) => {
    try {
        const response = await GetDataToken(`/api/get-profile/`);
        dispatch({
            type: GET_USER_PROFULE,
            payload: response,
            loading: true
        })

    } catch (e) {
        dispatch({
            type: GET_USER_PROFULE,
            payload: e.response,
        })
    }
}

export const forgetPasswordaction = (data) => async (dispatch) => {
    try {
        const response = await InsertDataAuth(`/api/forget-password/`, data);
        dispatch({
            type: FOREGT_PASSWORD,
            payload: response,
            loading: true
        })

    } catch (e) {
        dispatch({
            type: FOREGT_PASSWORD,
            payload: e.response,
        })
    }
}
export const resetPasswordaction = (data) => async (dispatch) => {
    try {
        const response = await InsertData(`/api/change-password/`, data);
        dispatch({
            type: ChangePassword,
            payload: response,
            loading: true
        })

    } catch (e) {
        dispatch({
            type: ChangePassword,
            payload: e.response,
        })
    }
}
export const updateUserProfileDataaction = (body) => async (dispatch) => {
    try {
        const response = await InsertDataWithImage(`/api/update-profile-data/`, body);
        dispatch({
            type: UPDATE_USER_PROFULE,
            payload: response,
            loading: true
        })

    } catch (e) {
        dispatch({
            type: UPDATE_USER_PROFULE,
            payload: e.response,
        })
    }
}